import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import InnerBox from '@repo/ui/inner-box'
import Loader from '@repo/ui/loader'
import { LogSection } from '@repo/ui/log-section'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getHostFamilyLecComments } from '../../../api/host-families/host-family-lec-comments/get-host-family-lec-comments'

type Props = {
  id: number
}

const HostFamilyLecComments = ({ id }: Props) => {
  const { data: hostFamilyLecComments, isPending } = useQuery({
    queryKey: ['host-family-lec-comments'],
    queryFn: () => getHostFamilyLecComments({ hostFamilyId: id, filter: { sharedToOl: true } }),
    enabled: !!id
  })

  if (isPending) return <Loader center />

  return (
    <InnerBox className="rounded-xl">
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        LEC comments
      </Typography>
      <div className="h-4" />
      {hostFamilyLecComments?.data && hostFamilyLecComments.data.length === 0 && (
        <Typography variant="tag" color={tailwindColors.grey.light.active}>
          No comments available
        </Typography>
      )}
      <LogSection
        data={
          hostFamilyLecComments?.data?.map((comment) => ({
            comment: comment.comment,
            updatedAt: new Date(comment.updatedAt)
          })) || []
        }
        dateFormatter={(date) => DateFormatter.ddMMyyyyHHmm(date)}
      />
    </InnerBox>
  )
}

export default HostFamilyLecComments
